import { computed, Injectable, signal } from '@angular/core';
import { updateSignalState } from '../../utils/update-signal';

export interface ApplicationState {
  isDrawerOpen: boolean;
  requestStatus: 'loading' | 'fulfilled' | 'pending';
}

@Injectable({
  providedIn: 'root',
})
export class AppState {
  // State
  private readonly appState = signal<ApplicationState>({
    isDrawerOpen: false,
    requestStatus: 'loading',
  });

  // Selektors
  public isDrawerOpen = computed(() => this.appState().isDrawerOpen);

  // Modifier
  public toggleDrawer() {
    updateSignalState(this.appState, 'isDrawerOpen', !this.isDrawerOpen());
  }
}
